export enum LOAD_POSTING_FORM_LOCATION_STATE {
    PARAM_NAME = "load-posting-form"
}
